import { ActionReducerMap } from '@ngrx/store';

export const featureKey = 'signup';

import {
    State as signupDataState,
    reducer as signupDataReducer
} from 'app/signup/features/data/data.reducer';
export  {
    State as signupDataState,
    reducer as signupDataReducer
} from 'app/signup/features/data/data.reducer';
export { SignupDataEffects } from 'app/signup/features/data/data.effects';

import {
    State as signupCategoriesState,
    reducer as signupCategoriesReducer
} from 'app/signup/features/categories/categories.reducer';
export {
    State as signupCategoriesState,
    reducer as signupCategoriesReducer
} from 'app/signup/features/categories/categories.reducer';
export { SignupCategoriesEffects } from 'app/signup/features/categories/categories.effects';

export interface SignupState {
    data: signupDataState,
    categories: signupCategoriesState
}

export const reducer: ActionReducerMap<SignupState> = {
    data: signupDataReducer,
    categories: signupCategoriesReducer,
};
